// DashboardDeliverablesStatsCard — small white "Deliverables" card on the
// program dashboard's right column. Single line of 4 numbers + label cells:
// Done (sage), Review (amber), Active (forest), Total (text). Counts derive
// from the same deliverables/submissions/statuses payload the rest of the
// dashboard already loads.

import { View } from "react-native";

import { StatStrip } from "../../aspects/StatStrip";
import { PANE_THEMES } from "../../brand/paneThemes";

const STUDENT_THEME = PANE_THEMES.Student;

import type {
  Deliverable,
  TeamDeliverableStatusRow,
  TeamSubmissionRow,
} from "../../../types/database";


export type DashboardDeliverablesStatsCardProps = {
  deliverables: Deliverable[];
  submissions: TeamSubmissionRow[];
  statuses: TeamDeliverableStatusRow[];
};

export function DashboardDeliverablesStatsCard({
  deliverables,
  submissions,
  statuses,
}: DashboardDeliverablesStatsCardProps) {
  const total = deliverables.length;
  const submittedIds = new Set(submissions.map((s) => s.deliverable_id));
  const statusById = new Map<string, TeamDeliverableStatusRow>();
  for (const s of statuses) statusById.set(s.deliverable_id, s);

  let done = 0;
  let review = 0;
  for (const id of submittedIds) {
    const s = statusById.get(id);
    if (s?.status === "passed") done += 1;
    else review += 1;
  }
  const now = Date.now();
  let active = 0;
  for (const d of deliverables) {
    if (submittedIds.has(d.id)) continue;
    if (d.opens_at && new Date(d.opens_at).getTime() > now) continue;
    active += 1;
  }

  const cells = [
    { label: "Done", value: done, color: STUDENT_THEME.success },
    { label: "Review", value: review, color: STUDENT_THEME.accent },
    { label: "Active", value: active, color: STUDENT_THEME.textOnSurface },
    { label: "Total", value: total, color: STUDENT_THEME.textOnSurface },
  ];

  return (
    <StatStrip
      theme={STUDENT_THEME}
      eyebrow="Deliverables"
      cells={cells}
    />
  );
}
